export default __webpack_public_path__ + "e36fb1afa062dab5802703f45bf83483.svg";